import { Component, OnInit } from '@angular/core';
import { DeleteConfirmComponent, SharedService } from '../../shared';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingService } from '../setting.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImagingCenter } from '../../model';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'ft-imaging-center-setting',
	templateUrl: './imaging-center-setting.component.html',
	styleUrls: ['./imaging-center-setting.component.scss'],
})
export class ImagingCenterSettingComponent implements OnInit {
	form: FormGroup;
	imagingCenters!: any[];
	deletable: boolean = false;

	constructor(
		private fb: FormBuilder,
		private sharedService: SharedService,
		private snack: MatSnackBar,
		private _dialog: MatDialog,
		private settingService: SettingService,
		private _translate: TranslateService
	) {
		this.form = this.fb.group(new ImagingCenter());
	}

	onSave(center: ImagingCenter) {
		this.settingService[
			center.id ? 'updateImagingCenter' : 'createImagingCenter'
		](center).subscribe(value => {
			if (value) {
				this.snack.open(this._translate.instant('CHANGES_SAVED'), '', {
					duration: 2000,
				});
				this.getCenters();
			}
		});
	}

	ngOnInit() {
		this.getCenters();
	}

	private getCenters() {
		this.sharedService.getImagingCenters().subscribe(centers => {
			this.imagingCenters = centers;
			this.deletable = centers.length > 1;
		});
	}

	editCenter(center: any) {
		this.form.patchValue(center);
	}

	duplicateCenter(center: ImagingCenter) {
		this.settingService
			.duplicateCenter(center.id)
			.subscribe((duplicatedCenter: any) => {
				this.form.patchValue(duplicatedCenter);
			});
	}

	deleteCenter(center: any) {
		this._dialog
			.open(DeleteConfirmComponent)
			.afterClosed()
			.subscribe(confirmed => {
				if (confirmed)
					this.settingService
						.deleteImagingCenter(center.id)
						.subscribe(ok => {
							if (ok) {
								this.snack.open(
									this._translate.instant('DELETED'),
									'',
									{ duration: 2000 }
								);
								this.getCenters();
							}
						});
			});
	}
}
